import React, { useEffect, useState, useContext, useRef } from 'react';
import Counsellorsidebar from './sidebar/sidebar';
import user from "../../assets/img/user.png";
import "./users.css";
import { Link } from 'react-router-dom';
import Parse from 'parse';
import { AuthContext } from '../../auth';
import { Redirect } from 'react-router-dom';
import swal from 'sweetalert';
import Peer from 'peerjs';
import { PeerjsContext } from '../../peerContext';
import { callContext } from '../../callContext';


const Users = (props) => {

    //userProfile
    const [relationship, setRelationship] = useState('');
    const [substances, setSubstances] = useState('');
    const [usagetime, setUsagetime] = useState('');
    const [frequency, setFrequency] = useState('');
    const [treatment, setTreatment] = useState('');
    const [complaint, setComplaint] = useState('');
    //userProfile ends

    const [name, setName] = useState('');
    const [age, setAge] = useState('');
    const [note, setNote] = useState('');
    const [notes, setNotes] = useState([]);
    const [peerid,setPeerid] = useState('');
    const [logedinuser, setLogedinuser] = useContext(AuthContext);
    const id = props.match.params.id;
    const peerRef = useContext(PeerjsContext);
    const callProp = useContext(callContext);

    useEffect(() => {
        const User = Parse.Object.extend("User");
        const query = new Parse.Query(User);

        query.get(id)
            .then((patient) => {                
                console.log(patient.id);
                setName(patient.get("name"));
                setPeerid(patient.get("peerId"));
                console.log(peerid);
                const UserNote = Parse.Object.extend("UserNote");
                const query = new Parse.Query(UserNote);
                query.equalTo("patientid", id).find().then((patientnotes) => {
                    
                    setNotes(patientnotes)
                })
            }, (error) => {
                console.log(error);
            })

            //retrives data from UserProfile
            const UserProfile = Parse.Object.extend("UserProfile");
            const nquery = new Parse.Query(UserProfile);
            nquery.equalTo("user_id",id).find().then((user)=>{
                console.log(user);
                setRelationship(user[0].get("relationship"));
                setSubstances(user[0].get("substances"));
                setUsagetime(user[0].get("usagetime"));
                setFrequency(user[0].get("frequency"));
                setTreatment(user[0].get("treatment"));
                setComplaint(user[0].get("complaint"));
            },(error)=>{
                console.log(error);
                swal("Oops","Could not retrieve patient data","error")
            })

    }, [])

    const handleSubmit = (e) => {
        e.preventDefault();
        const UserNote = Parse.Object.extend("UserNote");
        const userNote = new UserNote();
        userNote.set("patientid", id);
        userNote.set("note", note);
        userNote.save()
            .then((data) => {
                swal("Addedd!", "Note added", "success");
                console.log(data);
                console.log(data.get("note"));
                console.log("inside notes");
                let newNotes = [...notes];
                newNotes.push(data);
                setNotes(newNotes);
            })
            .catch((err) => {
                swal("Oops!", "Seems like we couldn't add your note...Please try again in sometime", "error");
            })
    }

    const handleCall = () => {
        console.log('Peerref', peerRef)
        navigator.getUserMedia = navigator.getUserMedia || navigator.webkitGetUserMedia || navigator.mozGetUserMedia;
        navigator.getUserMedia({ video: false, audio: true }, (stream) => {
            callProp.current = peerRef.current.call(peerid, stream, { metadata: { type: 'audio' } });
            callProp.current.on('stream', (remoteStream) => {
                console.log("on call", remoteStream);
                // setOnaudiocall(true);
                // setAudioSrc(remoteStream);
            });
        }, (err) => {
            console.error('Failed to get local stream', err);
        });
    }

    return (
        <div>
            {console.log(logedinuser)}
            {(logedinuser == null) && (
                <Redirect to="/counsellor/login" />
            )}
            <Counsellorsidebar head='Patient' />
            <div className="container">
                <div className='card mt-4'>
                    <div className='row'>
                        <div className='col-lg-12  text-center'>
                            <img src={user} className='user' alt="user"/>
                        </div>
                        <div className='col-lg-12 text-center'>
                            <Link to={`/counsellorchat/${logedinuser.concat(id)}`}><button className="patientbutton"><i className="fas fa-comment-alt"></i>   Enter Chat Room</button></Link>
                            {/* <Link to={`/decline/${id}`}><button onClick={handleCall} className="patientbutton"><i className="fas fa-phone"></i>   Have a Call</button></Link> */}
                            {/* <button className="patientbutton" onClick={handleCall}><i className="fas fa-phone"></i>   Have a Call</button> */}
                        </div>
                        <div className='patientdetails col-lg-10 px-5 '>
                            <p className="d-inline-block mr-5" >Name : {name}</p>
                            <p className="d-inline-block">Age : {age}</p>
                            <p>Relation :{relationship}</p>
                            <p>Substances :{substances}</p>
                            <p>Usage time :{usagetime}</p>
                            <p>Frequency :{frequency}</p>
                            <p>Treatment :{treatment}</p>
                            <p>Complaint :{complaint}</p>
                            <div>YOUR NOTES :
                                
                                    {notes.map((note,i) => {
                                        return (
                                            <p key={i}>
                                                {i+1 }
                                                {' '}
                                                {note.get("note")}
                                            </p>
                                        )
                                    })}
                                
                            </div>
                            <form onSubmit={handleSubmit}>
                                <textarea
                                    className="textbox w-75"
                                    value={note}
                                    onChange={e => setNote(e.target.value)}
                                    placeholder="Add more Notes" />
                                    <br/>
                                {/* <i class="fas fa-pencil-alt"></i>Add More Notes */}
                                {/* <input
                                    type="submit"
                                    className="patientbutton addbtn" /> */}
                                <button className="patientbutton addbtn">
                                    <i class="fas fa-pencil-alt"></i>Add More Notes
                                </button>
                            </form>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    )
}

export default Users